import { get, map, sumBy } from 'lodash';
import { custom } from 'utils/Api';
import { FETCH_TICKETS_FAILURE, FETCH_TICKETS_REQUEST, FETCH_TICKETS_SUCCESS } from './constants';

export const requestPayticket = () => ({
  type: FETCH_TICKETS_REQUEST,
});

export const requestPayticketSuccess = (paytickets, orgCompanyIds) => ({
  type: FETCH_TICKETS_SUCCESS,
  paytickets,
  orgCompanyIds,
});

export const requestPayticketFailure = error => ({
  type: FETCH_TICKETS_FAILURE,
  error,
});

export const fetchUserPaytickets = year => async (dispatch, getState) => {
  dispatch(requestPayticket());
  const {
    loginReducer: { user: { EmployeeMasterID } },
    profileReducer: { employeeDetailOrgList },
    payticketReducer: { orgCompanyIds }
  } = getState();
  try {
    let orgCompIds = [];
    if (orgCompanyIds) {
      orgCompIds = orgCompanyIds;
    } else if (employeeDetailOrgList) {
      orgCompIds = map(employeeDetailOrgList, o => get(o, 'Entity.OrgCompanyID'));
    } else {
      const now = new Date().toISOString();
      const fetchConfig = {
        url: '/api/QDataWebModel/EmployeeDetailOrg',
        method: 'GET',
        params: {
          $filter: `Entity/EmployeeDetailID ge ${EmployeeMasterID}1 and Entity/EmployeeDetailID le ${EmployeeMasterID}9 and (Entity/EmployeeStatus eq '0' or (Entity/EmployeeStatus ge '4'  and Entity/EmployeeStatus le '7')) and Entity/Begda le datetime'${now}' and Entity/Endda ge datetime'${now}'`,
        },
      };
      const orgs = get(await custom(fetchConfig), 'data');
      orgCompIds = map(orgs, o => get(o, 'Entity.OrgCompanyID'));
    }

    const requests = map(orgCompIds, orgCompId => (
      custom({
        url: '/api/PaySalary/Fetch',
        method: 'POST',
        data: {
          EmployeeMasterID,
          PayYear: year,
          OrgCompanyID: orgCompId,
        },
      })
    ));
    const res = await Promise.all(requests);
    const tickets = map(res, r => get(r, 'data'));

    const paytickets = [];
    map(tickets, ({ Employees, Header }) => {
      if (!Employees.length) return;
      const employee = Employees[0];
      const firstRow = [];
      const restRows = [];
      map(employee.Columns, (col) => {
        if (col.SkNr === -1) {
          firstRow.push({
            PaySalaryID: col.PaySalaryID,
            PaySalaryName: col.PaySalaryName,
            Samtals: col.Samtals,
            SkNr: '',
            TotalPayField: '',
          });
        }
      });
      if (firstRow.length) {
        restRows.push({
          PaySalaryID: '',
          PaySalaryName: '',
          Samtals: '',
          SkNr: -1,
          TotalPayField: sumBy(firstRow, 'Samtals'),
        });
      }
      map(employee.Columns, (col) => {
        if (col.SkNr !== -1) {
          restRows.push({
            PaySalaryID: col.PaySalaryID,
            PaySalaryName: col.PaySalaryName,
            Samtals: col.Samtals,
            SkNr: '',
            TotalPayField: '',
          });
          restRows.push({
            PaySalaryID: '',
            PaySalaryName: '',
            Samtals: '',
            SkNr: col.SkNr,
            TotalPayField: get(col, 'Samtals'),
          });
        }
      });
      paytickets.push({
        ...employee,
        Header,
        firstRow,
        restRows,
      });
    });
    dispatch(requestPayticketSuccess(paytickets, orgCompIds));
  } catch (error) {
    dispatch(requestPayticketFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/sites/payTickets/actions.js